import { render, staticRenderFns } from "./RoommateRemove.vue?vue&type=template&id=6f09f944&"
import script from "./RoommateRemove.vue?vue&type=script&lang=js&"
export * from "./RoommateRemove.vue?vue&type=script&lang=js&"
import style0 from "./RoommateRemove.vue?vue&type=style&index=0&id=6f09f944&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports